var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-company-edit-wrapper",
    { attrs: { "no-scroll": "", company: _vm.value } },
    [
      _c(
        "w-button-bar",
        { attrs: { slot: "actions" }, slot: "actions" },
        [
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Terminal koppelen",
                  expression: "'Terminal koppelen'",
                },
              ],
              attrs: { disabled: _vm.registerDisabled },
              on: {
                click: function ($event) {
                  return _vm.registerClicked()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "plus" } })],
            1
          ),
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Nickname bewerken",
                  expression: "'Nickname bewerken'",
                },
              ],
              attrs: { disabled: _vm.changeNicknameDisabled },
              on: {
                click: function ($event) {
                  return _vm.changeNicknameClicked()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "pen" } })],
            1
          ),
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Terminal ontkoppelen",
                  expression: "'Terminal ontkoppelen'",
                },
              ],
              attrs: { disabled: _vm.unregisterDisabled },
              on: {
                click: function ($event) {
                  return _vm.unregisterClicked()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "minus" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { staticStyle: { "flex-grow": "1", "flex-shrink": "1" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-data-table", {
                staticStyle: { "flex-grow": "1" },
                attrs: {
                  compare: _vm.terminalCompareFunc,
                  columns: _vm.columns,
                  items: _vm.connectedTerminals,
                  "selected-items": _vm.selectedRows,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.isRegistering
        ? _c("app-company-ctep-register", {
            attrs: { company: _vm.value },
            on: {
              close: function ($event) {
                _vm.isRegistering = false
              },
              refresh: function ($event) {
                return _vm.fetch()
              },
            },
          })
        : _vm._e(),
      _vm.toChangeNicknameTerminal
        ? _c("app-company-ctep-change-nickname", {
            attrs: { value: _vm.toChangeNicknameTerminal },
            on: {
              close: function ($event) {
                _vm.toChangeNicknameTerminal = null
              },
              refresh: function ($event) {
                return _vm.fetch()
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }